import * as React from "react"

function Logo(props) {
  return (
    <svg
      {...props}
      width={35}
      height={35}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.003 0l-3.33 8.772H0L4.899 0h15.104z" fill="#36F" />
      <path
        d="M33.328 8.772H16.672L19.971 0h10.483l2.874 8.772z"
        fill="#F43D8D"
      />
      <path d="M50 8.772H33.328L30.42 0h14.746L50 8.772z" fill="#36F" />
      <path
        d="M0 8.772v32.691C0 46.083 3.821 50 8.328 50s8.328-3.916 8.328-8.537V8.772H0z"
        fill="#3333B0"
      />
      <path
        d="M16.672 8.772v32.691C16.672 46.083 20.493 50 25 50s8.328-3.916 8.328-8.537V8.772H16.672z"
        fill="#D10B54"
      />
      <path
        d="M33.328 8.772v32.691c0 4.62 3.821 8.537 8.328 8.537s8.328-3.916 8.328-8.537V8.772H33.328z"
        fill="#3333B0"
      />
      <path
        d="M10.81 14.96c.114.172.212.375.294.579-.098-.204-.196-.392-.294-.58zM39.027 14.85c-.13.266-.261.532-.409.783.099-.282.23-.548.409-.783z"
        fill="#fff"
      />
      <path
        d="M11.104 15.523a19.811 19.811 0 01-.294-.58c.13.189.229.377.294.58zM39.027 14.85c-.13.266-.261.532-.409.783.099-.282.23-.548.409-.783z"
        fill="#979798"
      />
      <path
        d="M44.187 16.416c0 .298-.05.58-.147.846-.098.22-.212.439-.327.658-3.478 6.579-10.597 11.074-18.81 11.074-8.15 0-15.22-4.433-18.73-10.933a53.928 53.928 0 01-.49-.956 2.428 2.428 0 01-.098-.689c0-1.504 1.273-2.726 2.84-2.726a2.88 2.88 0 012.401 1.254c.098.188.18.376.294.58v.015c2.564 4.793 7.773 8.083 13.782 8.083 5.96 0 11.137-3.243 13.733-7.99.147-.265.278-.516.408-.782a2.88 2.88 0 012.319-1.16c1.551.016 2.825 1.222 2.825 2.726z"
        fill="#fff"
      />
      <path
        d="M5.683 17.12c.147.314.31.643.49.956a2.556 2.556 0 01-.49-.955zM11.104 15.523a19.811 19.811 0 01-.294-.58c.13.189.229.377.294.58zM38.618 15.649c.099-.282.23-.549.409-.784-.13.25-.261.517-.409.784zM44.04 17.262a3.119 3.119 0 01-.327.658c.115-.204.229-.423.327-.658z"
        fill="#B3B3B5"
      />
    </svg>
  )
}

export default Logo
